import api from "@/lib/api";

const KEY = "tp_visitor_id";
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
const CURRENCY = "AUD";

function visitorId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(KEY, id);
  }
  return id;
}

let gaReady = false;
let suppressed = false;

/** Admin sessions skew the numbers, so they are never sent to GA. */
export function setAnalyticsSuppressed(value) {
  suppressed = value;
  if (window.gtag) window.gtag("set", { send_page_view: false });
}

/** Loads gtag.js once, with page views sent manually so each SPA route counts separately. */
export function initGA() {
  if (gaReady || !GA_ID || typeof window === "undefined") return;
  gaReady = true;
  // Preview/staging hosts are tagged as internal traffic, which GA4 excludes from reports.
  const internal = window.location.hostname !== "teachingpathways.com.au";

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    send_page_view: false,
    anonymize_ip: true,
    ...(internal ? { traffic_type: "internal" } : {}),
  });
}

function ga(event, params) {
  if (!gaReady || suppressed || !window.gtag) return;
  window.gtag("event", event, params);
}

let lastPath = null;

/** Records a first-party page view and a GA4 page_view for this exact route. */
export function trackPageView(path, internalHost = false) {
  if (path === lastPath) return;
  lastPath = path;
  if (!suppressed && !internalHost) {
    api.post("/track", {
      path,
      referrer: document.referrer || "",
      visitor_id: visitorId(),
      width: window.innerWidth,
    }).catch(() => {});
  }
  ga("page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

const gaItem = (item) => ({
  item_id: item.item_id,
  item_name: item.name || item.item_name || item.item_id,
  item_category: item.kind || "resource",
  price: Number(item.price || item.amount || 0),
  quantity: 1,
});

export const trackViewItem = (item) =>
  ga("view_item", { currency: CURRENCY, value: Number(item.price || 0), items: [gaItem(item)] });

export const trackAddToCart = (item) =>
  ga("add_to_cart", { currency: CURRENCY, value: Number(item.price || 0), items: [gaItem(item)] });

export const trackBeginCheckout = (items, total) =>
  ga("begin_checkout", { currency: CURRENCY, value: Number(total || 0), items: items.map(gaItem) });

export const trackPurchase = (transactionId, items, total) =>
  ga("purchase", {
    transaction_id: transactionId,
    currency: CURRENCY,
    value: Number(total || 0),
    items: (items || []).map(gaItem),
  });
